import { getIoTStatusInterval, IoT_STATUS_COLORS } from "components/products/products-list/iot-status-colors";
import * as ko from "knockout";

export class ProductSearchCriteria {
  generalSearch: KnockoutObservable<string>;
  product_id: KnockoutObservable<string>;
  model_id: KnockoutObservable<string>;
  part_id: KnockoutObservable<string>;
  serial_id: KnockoutObservable<string>;
  Page: KnockoutObservable<number>;
  Rows: KnockoutObservable<number>;
  page_dir: KnockoutObservable<string>;
  sort_dir: KnockoutObservable<string>;
  created_dttm_last_value: KnockoutObservable<Date>;
  sort_field_last_value: KnockoutObservable<string>;
  sort_field: KnockoutObservable<string>;
  user_def1: KnockoutObservable<string>;
  asset_id: KnockoutObservable<string>;
  counter_readings_request_status: KnockoutObservable<string>;
  hostname: KnockoutObservable<string>;
  product_type: KnockoutObservable<string>;
  address_search: KnockoutObservable<string>;
  ip_address: KnockoutObservable<string>;
  page_type: KnockoutObservable<string>;
  contract_filter: KnockoutObservable<string>;
  service_model: KnockoutObservable<string>;
  ext_last_connection_status: KnockoutObservable<string>;
  ext_last_connection_start_date: KnockoutObservable<Date>;
  ext_last_connection_end_date: KnockoutObservable<Date>;

  constructor(item?) {
    this.generalSearch = ko.observable(item?.generalSearch);
    this.product_id = ko.observable(item?.product_id);
    this.model_id = ko.observable(item?.model_id);
    this.part_id = ko.observable(item?.part_id);
    this.serial_id = ko.observable(item?.serial_id);
    this.Page = ko.observable(item?.Page || 0);
    this.Rows = ko.observable(item?.Rows || 15);
    this.page_dir = ko.observable(item?.page_dir);
    this.sort_dir = ko.observable(item?.sort_dir);
    this.sort_field = ko.observable(item?.sort_field);
    this.sort_field_last_value = ko.observable(item?.sort_field_last_value);
    this.created_dttm_last_value = ko.observable(item?.created_dttm_last_value);
    this.user_def1 = ko.observable(item?.user_def1);
    this.asset_id = ko.observable(item?.asset_id);
    this.counter_readings_request_status = ko.observable(item?.counter_readings_request_status);
    this.hostname = ko.observable(item?.hostname);
    this.product_type = ko.observable(item?.device_type);
    this.address_search = ko.observable(item?.address_search);
    this.ip_address = ko.observable(item?.ip_address);
    this.page_type = ko.observable(item?.page_type);
    this.contract_filter = ko.observable(item?.contract_filter);
    this.service_model = ko.observable(item?.service_model);
    this.ext_last_connection_status = ko.observable(item?.ext_last_connection_status);
    this.ext_last_connection_start_date = ko.observable(item?.ext_last_connection_start_date);
    this.ext_last_connection_end_date = ko.observable(item?.ext_last_connection_end_date);

    this.ext_last_connection_status.subscribe((status) => {
      const interval = getIoTStatusInterval(status);
      this.ext_last_connection_start_date(interval.startDate);
      this.ext_last_connection_end_date(interval.endDate);
    });
  }
}
